module.exports = __webpack_public_path__ + "static/media/crime.756c4845.png";